import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
    handler as reqHandler,
    onError as reqOnError
} from './requestHandler'

import {
    handler as resHandler,
    onError as resOnError
} from './responseHandler'

const instance = axios.create()

Vue.use(VueAxios, instance)

instance.defaults.baseURL = process.env.VUE_APP_BASE_URL

instance.interceptors.request.use(reqHandler, reqOnError)
instance.interceptors.response.use(resHandler, resOnError)

export default instance
